// extracted by mini-css-extract-plugin
export default {"carousel":"U3","ingredient":"V3","swiper-pagination-bullet":"W3","swiper-pagination-bullet-active":"X3","swiper_carousel":"Y3","swiper_pagination":"Z3","arrows":"a4","arrow_navigation":"b4"};
    if(module.hot) {
      // 1713809680068
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  